import { render } from "./kumo5.vue?vue&type=template&id=e70cbb18&scoped=true"
import script from "./kumo5.vue?vue&type=script&lang=js"
export * from "./kumo5.vue?vue&type=script&lang=js"

import "./kumo5.vue?vue&type=style&index=0&id=e70cbb18&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70cbb18"]])

export default __exports__